import { getEmailMetadataAttachment } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import invariant from 'react-utils/invariant';
import { setAttachment } from 'conversations-message-history/common-message-format/operators/commonMessageSetters';
import { setMetadataSubject } from 'conversations-message-history/common-message-format/operators/emailMetadataSetters';
export const updateEmailSubject = (nextSubject, commonMessage) => {
  const emailMetadataAttachment = getEmailMetadataAttachment(commonMessage);
  invariant(!!emailMetadataAttachment, 'emailMetadataAttachment is required to set subject');
  const updatedCommonMessage = setAttachment(setMetadataSubject(nextSubject, emailMetadataAttachment), commonMessage);
  return updatedCommonMessage;
};